import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'completed',
    `
		display: flex;
		flex-direction: column;
		align-items: center;
	`
  ],
  [
    'completedIcon',
    theme => `
		color: ${theme.color.primary.default};
		margin-bottom: 20px;
	`
  ]
]);
